export const GIFT_CREATE_PAGE_STATIC_KEY = 'giftCreatePage'
export default GIFT_CREATE_PAGE_STATIC_KEY
